// src/hooks/useLocalization.ts
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { 
  SupportedLanguage, 
  SUPPORTED_LANGUAGES, 
  getLanguageFromURL, 
  LANGUAGE_STORAGE_KEY,
  getUserPreferredLanguage
} from '@/config/routes';
import { getColorPathForLanguage } from '@/config/colors';

export const useLocalization = () => {
  const { pathname } = useParams();
  const navigate = useNavigate();
  const currentLang = getLanguageFromURL(pathname || '');
  const langConfig = SUPPORTED_LANGUAGES[currentLang];

  useEffect(() => {
    const storedLang = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (!storedLang) {
      const preferredLang = getUserPreferredLanguage();
      localStorage.setItem(LANGUAGE_STORAGE_KEY, preferredLang);
    }
  }, []);

  const changeLanguage = (newLang: SupportedLanguage) => {
    if (newLang === currentLang) return;

    localStorage.setItem(LANGUAGE_STORAGE_KEY, newLang);

    // Get current color from URL
    const currentColor = document.querySelector<HTMLDivElement>('.full-screen')?.style.backgroundColor || '#FFFFFF';
    let hex = '#FFFFFF';
    
    // Parse RGB color if needed
    if (currentColor.startsWith('rgb')) {
      const match = currentColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      if (match) {
        hex = '#' + match.slice(1).map(n => parseInt(n).toString(16).padStart(2, '0')).join('').toUpperCase();
      }
    } else if (currentColor.startsWith('#')) {
      hex = currentColor;
    }
    
    const newPath = getColorPathForLanguage(hex, newLang);
    const finalPath = newLang === 'en' ? `/${newPath}` : `/${newLang}/${newPath}`;
    
    navigate(finalPath);
  };

  return {
    currentLang,
    langConfig,
    dir: langConfig.dir,
    title: langConfig.title,
    description: langConfig.description,
    changeLanguage
  };
};